import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private activeRequests = signal<number>(0);
  
  // Computed read-only signal that triggers spinner when requests > 0
  public isLoading = computed(() => this.activeRequests() > 0);

  /**
   * Increment active request counter
   */
  show() {
    this.activeRequests.update(n => n + 1);
  }

  /**
   * Decrement active request counter
   */
  hide() {
    this.activeRequests.update(n => Math.max(0, n - 1));
  }
}
